import type { FC } from 'react'
import InfinityScroll from '@g4g/ui/src/components/InfinityScroll'
import RecipientRadioOpt from '../RecipientRadioOpt'
import Spinner from '@g4g/ui/src/internal/Spinner'
import PlaceholderKorag from '@g4g/ui/src/internal/PlaceholderKorag'
import { useRecipientSelect } from '../page/RecipientSelectProvider'
import useRecipientGifters from '../hooks/useRecipientGifters'
import RecipientError from '../RecipientError'
import { logErrorMessage } from '@g4g/utils/src/react/error'

const NoResults: FC = () => {
  const { searchQuery } = useRecipientSelect()

  return (
    <PlaceholderKorag>
      <span>
        We could not find any users matching <br />
      </span>
      <span className="truncate max-w-[300px] font-bold inline-block px-2 py-0.5 mt-1 rounded-md bg-gray-600/50">
        {searchQuery}
      </span>
    </PlaceholderKorag>
  )
}

const GiftSection: FC = () => {
  const { loading, error, edges, fetchMore, empty, hasNextPage, cursor } = useRecipientGifters()

  if (loading) {
    return (
      <div className="flex justify-center text-white">
        <Spinner className="w-6 h-6 sm:w-12 sm:h-12" delay={100} />
      </div>
    )
  }

  if (error) {
    logErrorMessage(error, false, 'GiftSection')
    return <RecipientError message="Something went wrong when trying to find users" />
  }

  if (empty) {
    return <NoResults />
  }

  return (
    <InfinityScroll
      fetchMore={() => fetchMore({ variables: { after: cursor } })}
      hasNextPage={hasNextPage}
    >
      {edges.map(
        (edge) => edge.node && <RecipientRadioOpt key={edge.node.cosId} recipient={edge.node} />
      )}
    </InfinityScroll>
  )
}

export default GiftSection
